<!-----选择谈判单列表------>
<template>
  <div>
    <el-button type="primary" @click="openDrawer()">
      选择谈判单
    </el-button>

    <!--选择弹窗--->
    <jczh-drawer
      :visible.sync="drawerVisible"
      title="选择谈判采购单"
      size="800px"
      :el-attrs="{
        destroyOnClose: true,
        wrapperClosable: false
      }"
      @close="handleDrawerClose"
      @confirm="handleConfirm"
    >
      <div slot="content" class="m-t-20">
        <el-form :model="filterForm" inline label-suffix="：">
          <el-form-item label="采购项目名称">
            <el-input
              v-model="filterForm.projectName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="谈判名称">
            <el-input
              v-model="filterForm.orderName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="发布时间">
            <jczh-date-picker
              v-model="publishTimeRange"
              type="datetimeRange"
              :default-time="['00:00:00', '23:59:59']"
              :append-to-body="false"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">查询</el-button>
          </el-form-item>
        </el-form>

        <jczh-table-content
          ref="table"
          :data="listData"
          :option="tableOptions"
          pagination
          :page.sync="page"
          :limit.sync="size"
          :total="total"
          selection
          table-id="orderId"
          :selected="selectedRows"
          @select-all="handleSelectAll"
          @select="handleSelect"
        />
      </div>
    </jczh-drawer>
  </div>
</template>
<script>
import {
  negotiationV2StatusDict,
  negotiationV2TypeDict
} from '@/dictionary/project/negotiation-v2'
import { projectTypeDict } from '@/dictionary/project/common'
import { getNegotiationV2ListApi } from '@/api/procure/negotiation-v2'

import listFilterMixin from '@/mixins/list-filter-mixin'
import { cloneDeep, uniqBy, differenceBy } from 'lodash'

const tableOptions = [
  { label: '采购项目名称', prop: 'projectName', minWidth: 120 },
  { label: '谈判名称', prop: 'orderName', minWidth: 120 },
  { label: '谈判编号', prop: 'orderCode', minWidth: 120 },
  {
    label: '项目类型',
    prop: 'projectType',
    minWidth: 120,
    filter: value => projectTypeDict.translate(value).label || '-'
  },
  {
    label: '竞争方式',
    prop: 'competeType',
    minWidth: 120,
    filter: value => negotiationV2TypeDict.translate(value).label || '-'
  },
  { label: '发布日期', prop: 'releaseTime', minWidth: 120, isNormDay: true },
  {
    label: '报名截止时间',
    prop: 'offerEndTime',
    minWidth: 120,
    isNormMinute: true
  },
  {
    label: '状态',
    prop: 'orderStatus',
    minWidth: 120,
    filter: value => negotiationV2StatusDict.translate(value).label || '-'
  },
  {
    label: '收到的报价',
    prop: 'offerCnt',
    minWidth: 120,
    filter: value => `共${value}条报价`
  }
]
export default {
  mixins: [listFilterMixin],

  model: {
    event: 'change',
    prop: 'selected'
  },

  props: {
    selected: {
      type: Array,
      default: () => []
    },

    inStatus: {
      type: Array,
      default: () => []
    },

    isAllowCandidate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      drawerVisible: false,

      filterForm: {
        projectName: '',
        orderName: '',
        releaseTimeStart: '',
        releaseTimeEnd: ''
      },

      listData: [],
      selectedRows: [],
      unSelectedRows: [],
      total: 0,
      tableOptions
    }
  },

  computed: {
    publishTimeRange: {
      get() {
        return [
          this.filterForm.releaseTimeStart,
          this.filterForm.releaseTimeEnd
        ]
      },
      set(val) {
        if (val?.length) {
          this.filterForm.releaseTimeStart = val[0]
          this.filterForm.releaseTimeEnd = val[1]
        }
      }
    }
  },

  watch: {
    selected: {
      handler: function(val) {
        this.selectedRows = cloneDeep(val) || []
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    openDrawer() {
      this.drawerVisible = true
      this.getList()
    },

    /**
     * 关闭弹窗
     */
    handleDrawerClose() {
      this.selectedRows = cloneDeep(this.selected) || []
      this.drawerVisible = false
    },

    /**
     * 确认选择
     */
    handleConfirm() {
      this.$emit('change', cloneDeep(this.selectedRows))
      this.drawerVisible = false
    },

    /**
     * 搜索查询
     */
    search() {
      this.page = 1
      this.size = 10
      this.getList()
    },

    /**
     * 获取列表
     */
    async getList() {
      // this.epitaxy()
      const params = {
        ...this.filterForm,
        inStatus: this.inStatus.join(','),
        isAllowCandidate: this.isAllowCandidate ? 1 : undefined,
        page: this.page,
        size: this.size
      }
      try {
        const { data } = await getNegotiationV2ListApi(params)
        this.listData = data?.records || []
        this.total = data?.total || 0
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    /**
     * 获取选中项
     */
    handleSelect(selection, row) {
      let selectedSelection = []
      const orderIds = selection.map(el => el.orderId)
      selectedSelection = [...this.selected, ...selection]
      selectedSelection = uniqBy(selectedSelection, 'orderId')
      if (orderIds.includes(row.orderId)) {
        // 勾选, 将勾选项从未勾选项里剔除
        this.unSelectedRows = this.unSelectedRows.filter(
          el => el.orderId !== row.orderId
        )
      } else {
        // 取消勾选，将取消勾选项添加至未勾选数组里
        this.unSelectedRows.push(row)
      }
      this.selectedRows = differenceBy(
        selectedSelection,
        this.unSelectedRows,
        'orderId'
      )
    },

    /**
     * 选中所有
     */
    handleSelectAll(selection) {
      let selectedSelection = []
      const orderIds = this.listData.map(el => el.orderId)
      if (selection.length === 0) {
        // 当前页面全不选
        selectedSelection = this.selected.filter(k => {
          return !orderIds.includes(k.orderId)
        })
      } else {
        // 全选当前页面
        selectedSelection = [...this.selected, ...selection]
        selectedSelection = uniqBy(selectedSelection, 'orderId')
      }
      this.selectedRows = selectedSelection
    }
  }
}
</script>
